import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

/**
 * HTTP Interceptor for API authentication and common headers.
 *
 * Currently attaches JSON Accept headers to all /api/ requests.
 *
 * TODO: When a proper JWT auth flow is implemented:
 * - Inject AuthService to get the current token
 * - Attach `Authorization: Bearer <token>` header
 * - Handle 401 responses by redirecting to login
 *
 * This replaces the hardcoded Basic Auth credentials that were
 * previously embedded in individual services (security vulnerability).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // Only intercept API requests
  if (!req.url.includes('/api/')) {
    return next(req);
  }

  // Clone the request and add common headers
  const apiReq = req.clone({
    setHeaders: {
      'Accept': 'application/json',
      // Force Arabic language so Koha returns Arabic script titles
      // instead of Latin romanization (e.g. avoids "Darj al-durar fī tafsīr...")
      'Accept-Language': 'ar',

      // TODO: Replace with JWT Bearer token from AuthService
      // 'Authorization': `Bearer ${authService.getToken()}`,
    },
  });

  return next(apiReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Global error handling for auth issues
      if (error.status === 401) {
        // TODO: Redirect to login page
        console.error('[AuthInterceptor] Unauthorized — session may have expired');
      }
      return throwError(() => error);
    })
  );
};
